import { useSearchParams } from "react-router-dom";

export const useQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentParams = Object.fromEntries(searchParams.entries());

  const setQueryParams = (params, config = { retain: false }) => {
    const newParams = config.retain ? Object.fromEntries(searchParams.entries()) : {};

    Object.entries(params).forEach(([key, value]) => {
      if (value === null || value === undefined) {
        delete newParams[key];
      } else {
        newParams[key] = String(value);
      }
    });

    setSearchParams(newParams);
  };

  const removeQueryParams = (paramKey) => {
    // Create a mutable copy of the current params
    const newParams = Object.fromEntries(searchParams.entries());

    if (paramKey) {
      const keysToRemove = Array.isArray(paramKey) ? paramKey : [paramKey];
      keysToRemove.forEach((key) => {
        delete newParams[key];
      });
    }

    // Update the searchParams immediately
    setSearchParams(newParams);

    // Return the new parameters so they can be used immediately in your search payload.
    return newParams;
  };

  //FOR PAYLOADS

  const changeParamsStatus = (params) => {
    const paramsObj = Object.fromEntries(searchParams.entries());
    setQueryParams({ ...paramsObj, ...params });
  };

  return { currentParams, searchParams, setQueryParams, removeQueryParams, changeParamsStatus };
};
